module.exports = __webpack_public_path__ + "media/src/application/media/map-b0d944e171b3396cda53611e1363a2d0.svg";